import React from 'react';
import { CContainer, CButton } from '@coreui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import StockTable from '../../components/StockTable/StockTable';
import './Stock.scss';

const Stock = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateStock = () => {
    navigate('/stock/create');
  };

  return (
    <div className="stock-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('stock')}</div>
        <StockTable />
      </CContainer>
      <CButton
        color="primary"
        className="create-stock-fab"
        onClick={handleCreateStock}
        title={t('createStock')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

export default Stock; 